module.exports = __webpack_public_path__ + "img/CATEGORY ICON-22.5259938f.png";